<template>
  <div class="mit-storage-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Storage</v-card-title>
            <v-card-subtitle class="caption">CSAIL Storage Information</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="pt-5">
                <a href="https://tig.csail.mit.edu/data-storage/" target="_blank">Documenation</a>
              </h3>
              <p>CSAIL storage information.</p>

              <h3 class="pt-5">
                <a href="https://storage.csail.mit.edu/" target="_blank">Storage Tool</a>
              </h3>
              <p>View storage information and usage.</p>


            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitEmailPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
